import Splide from '@splidejs/splide'
import axios from 'axios'
import './contact-us'
import './contact-us-post'
import './map'

window.Splide = Splide
window.axios = axios
